import { render, staticRenderFns } from "./PetPage.vue?vue&type=template&id=4e8bc70c"
import script from "./PetPage.vue?vue&type=script&lang=js"
export * from "./PetPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports